import React from 'react';

const CareersCard = ({ companyPosition }) => {

  const careers = [
    {
      "title": "Solution Engineering - Associate, FICO Bengaluru",
      "date": "06/2023 - Present",
      "details": [
        "Led development of OM (Origination Manager) App using Java, Spring Boot, and JavaScript, showcasing expertise in platform development.",
        "Achieved 20% faster app loading through JavaScript optimization, demonstrating strong problem-solving and web development skills.",
        "Implemented bug fixes and elevated coding standards for enhanced application reliability, leveraging knowledge of computer science fundamentals.",
        "Managed EMEA projects, demonstrating adaptability and collaboration skills with international teams and cloud-based technologies.",
        "Crafted business logic for PLOR, showcasing expertise in scalable algorithm design and complex problem-solving.",
        "Designed UI components with JavaScript, jQuery, and CSS, meeting web development requirements and emphasizing attention to detail."
      ]
    },
    {
      "title": "Solution Engineering - Intern, FICO Bengaluru",
      "date": "01/2023 - 06/2023",
      "details": [
        "Developed Bicycle Rent Store app using Java, Spring Boot, Thymeleaf, and MySQL, showcasing proficiency in server-side development.",
        "Designed user interface with HTML, CSS3, and JavaScript, emphasizing usability and aesthetics.",
        "Improved platform performance through optimization and code refactoring, demonstrating problem-solving abilities and familiarity with cloud technologies.",
        "Contributed to fixing issues in FICO Platform project, showcasing analytical skills and knowledge of cloud-based data processing.",
        "Utilized JDBC for database connectivity, highlighting scripting language proficiency and rapid learning capabilities.",
        "Communicated effectively with team members, demonstrating strong written and verbal communication skills."
      ]
    },
    {
      "title": "Freelancer - Full Stack Developer and Flutter Developer, Hufnan Groups Somalia (Remote) / BusStop India Startup (India)",
      "date": "01/2021 - 06/2022",
      "details": [
        "Spearheaded development of websites and mobile apps using LAMP stack and Flutter UI toolkit, demonstrating proficiency in server-side and mobile app development.",
        "Implemented backend functionalities and database connectivity with PHP, MySQL, and Firebase, ensuring efficient data storage and processing.",
        "Designed user interfaces with SEO optimization and responsive design, meeting web development standards.",
        "Developed mobile app for local bus timings, showcasing problem-solving and analytical abilities.",
        "Adapted to new technologies, including Flutter, and effectively communicated with clients to deliver tailored solutions."
      ]
    }
  ];

  return (
    <div className='json-heading-wrapper'>
      [
      <div className="json-ui">
        {careers.map((career, index) => (
          <div key={index} className="json-project">
            <span>&#123;</span>
            <div className="json-property">
              <span className="json-key">"title":</span> <span className="json-value">"{career.title}"</span>,
            </div>
            <div className="json-property">
              <span className="json-key">"date":</span> <span className="json-value">"{career.date}"</span>,
            </div>
            <div className="json-property display-inline-block">
              <span className="json-key">"details":</span>
              <span className="json-value">[</span>
              <ul className="json-array">
                {career.details.map((detail, index) => (
                  <li key={index} className="json-array-item">"{detail}"{index < career.details.length - 1 && ","}</li>
                ))}
              </ul>
              <span className="json-value">]</span>
            </div>
            <span>&#125;{index < careers.length - 1 && ","}</span>
          </div>
        ))}
      </div>
      ]
    </div>
  );
}

export default CareersCard;
